<template>
	<div class="document_index">
		<div class="doc_content">
			<div class="main_left_menu" ref="mainLeftMent">
				<div class="left_title">
					<span>文档目录</span>
					<!-- <i class="el-icon-menu"></i> -->
				</div>
				<div class="doc_left_sidebar">
					<el-menu
					:default-active="onRoutes()"
					class="el_menu_left"
					:unique-opened="true"
					@open="handleOpen"
					@close="handleClose"
					router
					active-text-color="#F99C23">
						<!-- <el-menu-item index="1">
				        	<span slot="title">API接入流程</span>
				      	</el-menu-item> -->
				      	<el-submenu index="2">
				        	<span slot="title">接入指南</span>
				        	<el-menu-item index="/apiaccess">接入流程</el-menu-item>
					        <el-menu-item index="/Authorization">鉴权方案</el-menu-item>
				      	</el-submenu>

				  <el-submenu index="object">
					        <template slot="title">
					          	<span>物体识别</span>
					        </template>
					        <el-submenu index="15">
						        <template slot="title">
						          	<span>SKObjects-API</span>
						        </template>
						        <el-menu-item index="/skobj-api-userhelp">使用说明</el-menu-item>
						        <el-menu-item index="/skobj-api-objectsapi">Objects-API</el-menu-item>
						    </el-submenu>
						    <el-submenu index="10">
						        <template slot="title">
						          	<span>SKEye-iOS</span>
						        </template>
						        <el-menu-item index="/skeye-ios-userhelp">使用说明</el-menu-item>
						        <el-menu-item index="/skeye-ios-init">SDK初始化</el-menu-item>
						        <el-menu-item index="/skeye-ios-image">调用接口</el-menu-item>
						    </el-submenu>
						    <el-submenu index="11">
						        <template slot="title">
						          	<span>SKEye-Android</span>
						        </template>
						        <el-menu-item index="/skeye-android-userhelp">使用说明</el-menu-item>
						        <el-menu-item index="/skeye-android-init">SDK初始化</el-menu-item>
						        <el-menu-item index="/skeye-android-colorcast">图像偏色处理</el-menu-item>
						        <el-menu-item index="/skeye-android-image">调用接口</el-menu-item>
						    </el-submenu>
						    <el-submenu index="12">
						        <template slot="title">
						          	<span>SKEye-Linux</span>
						        </template>
						        <el-menu-item index="/skeye-linux-userhelp">使用说明</el-menu-item>
						        <el-menu-item index="/skeye-linux-init">SDK初始化</el-menu-item>
						        <el-menu-item index="/skeye-linux-image">调用接口</el-menu-item>
						    </el-submenu>
						    <el-submenu index="13">
						        <template slot="title">
						          	<span>SKEye-Windows</span>
						        </template>
						        <el-menu-item index="/skeye-win-userhelp">使用说明</el-menu-item>
						        <el-menu-item index="/skeye-win-init">SDK初始化</el-menu-item>
						        <el-menu-item index="/skeye-win-image">调用接口</el-menu-item>
						    </el-submenu>
						    <el-submenu index="14">
						        <template slot="title">
						          	<span>SKEye-Unity</span>
						        </template>
						        <el-menu-item index="/skeye-unity-userhelp">使用说明</el-menu-item>
						        <el-menu-item index="/skeye-unity-init">SDK初始化</el-menu-item>
						        <el-menu-item index="/skeye-unity-image">调用接口</el-menu-item>
						    </el-submenu>
					    </el-submenu>   

						<el-submenu index="face">
					        <template slot="title">
					          	<span>人脸识别</span>
					        </template>

							<el-submenu index="3">
								<template slot="title">
									<span>SKFace-iOS</span>
								</template>
								<el-menu-item index="/skface-ios-userhelp">使用说明</el-menu-item>
								<el-submenu index="3-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="/skface-ios-init">SDK初始化</el-menu-item>
									<el-menu-item index="/skface-ios-release">释放SDK资源</el-menu-item>
									<el-menu-item index="/skface-ios-trackinit">视频人脸识别与跟踪初始化</el-menu-item>
									<el-menu-item index="/skface-ios-track">视频人脸检测与跟踪</el-menu-item>
									<el-menu-item index="/skface-ios-setthreshold">设置人脸识别阈值</el-menu-item>
									<el-menu-item index="/skface-ios-getthreshold">获取人脸识别阈值</el-menu-item>
								</el-submenu>
								<el-submenu index="3-2">
									<template slot="title">本地接口</template>
									<el-menu-item index="/skface-ios-startregperson">开启人脸注册</el-menu-item>
									<el-menu-item index="/skface-ios-cancelregperson">停止人脸注册</el-menu-item>
									<el-menu-item index="/skface-ios-deleteperson">删除人员信息</el-menu-item>
									<el-menu-item index="/skface-ios-setperson">设置人脸属性</el-menu-item>
									<el-menu-item index="/skface-ios-setuploadbuffer">设置识别记录的缓存上限</el-menu-item>
									<el-menu-item index="/skface-ios-getpersondata">获取认识的人员数量及列表</el-menu-item>
									<el-menu-item index="/skface-ios-getpersoninfo">获取认识人员的详细信息</el-menu-item>
								</el-submenu>
								<el-submenu index="3-3">
									<template slot="title">事件接口</template>
									<el-menu-item index="/skface-ios-setevent">设置事件监听</el-menu-item>
									<el-menu-item index="/skface-ios-shortmemory">短时记忆功能</el-menu-item>
								</el-submenu>
								<el-submenu index="3-4">
									<template slot="title">FRM接口</template>
									<el-menu-item index="/skface-ios-getbindinfowithcode">提取FRM绑定码信息</el-menu-item>
									<el-menu-item index="/skface-ios-bindfrm">绑定FRM</el-menu-item>
									<el-menu-item index="/skface-ios-unbindfrm">解绑FRM</el-menu-item>
									<el-menu-item index="/skface-ios-getdevicebindinfo">获取终端当前绑定信息</el-menu-item>
									<el-menu-item index="/skface-ios-getdevicepersonstructure">获取当前终端所拥有的人员分组结构</el-menu-item>
									<el-menu-item index="/skface-ios-getdevicename">获取FRM终端名称</el-menu-item>
									<el-menu-item index="/skface-ios-grouppath">通过人员组ID获得人员组路径信息</el-menu-item>
									<el-menu-item index="/skface-ios-personlocalidserverid">人员本地ID转换为云端对应ID</el-menu-item>
								</el-submenu>
								<el-submenu index="3-5">
									<template slot="title">图片接口</template>
									<el-menu-item index="/skface-ios-imagedetect">人脸检测</el-menu-item>
									<!-- <el-menu-item index="/skface-ios-facefeaturecompare">人脸比对</el-menu-item> -->
								</el-submenu>
								<el-submenu index="3-6">
									<template slot="title">版本接口</template>
									<el-menu-item index="/skface-ios-getsdkversion">获取SDK版本号</el-menu-item>
									<el-menu-item index="/skface-ios-getkernelversion">获取人脸识别内核版本号</el-menu-item>
									<el-menu-item index="/skface-ios-getmodelversion">获得Model版本号</el-menu-item>
								</el-submenu>
							</el-submenu>

							<!--<el-submenu index="4">
					        	<template slot="title">
									<span>SKFace-Android</span>
								</template>
								<el-menu-item index="sk-face-sdk-win-skfaceandroidhelp">使用说明</el-menu-item>
								<el-submenu index="4-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="sk-face-sdk-win-sdkinitial">SDK初始化</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-sdkversion">获得SDK版本号</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-releasesdk">释放SDK资源</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-sdkkernel">获得人脸识别内核版本号</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-sdkmodel">获取Model版本号</el-menu-item>
								</el-submenu>
								<el-submenu index="4-2">
									<template slot="title">图片接口</template>
									<el-menu-item index="sk-face-sdk-win-imagefacetestd">人脸检测</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-imagefacecontrastd">人脸比对</el-menu-item>
								</el-submenu>
								<el-submenu index="4-3">
									<template slot="title">视频接口</template>
									<el-menu-item index="sk-face-sdk-win-voideinitialization">视频初始化</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voideseetingstranger">设置“陌生人短时记忆功能”打开、关闭</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidedetectiontracking">人脸检测与跟踪</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidedefrminformation">获取FRM绑定信息</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidelocal">获取本机当前绑定信息</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidebindingfrm">绑定FRM</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voideuntyingfrm">解绑FRM</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voideseetingmonitor">设置事件监听</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidefaceregister">开启人脸注册</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidecancelfaceregister">取消人脸注册</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidegetpeople">获取人的信息</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidepeoplename">设置名字</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidesex">设置性别</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidebrithday">设置生日</el-menu-item>

									<el-menu-item index="sk-face-sdk-win-voidedetails">设置细节</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidedeletepeople">删除一个人</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidegetperson">获取当前设备所关联人员库Person数量</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidepeopleselect">获取认识的人列表</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidesetequipment">获取设备名称</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidegrouping">获取当前设备所拥有的人员分组结构</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidetransformation">人员本地ID转换为云端对应ID</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidethreshold">设置人脸识别阈值</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voiderouter">人员的组ID转换为人员所在组的路径</el-menu-item>
								</el-submenu>	    
							</el-submenu>-->

							<el-submenu index="4">
					        	<template slot="title">
									<span>SKFace-Android</span>
								</template>
								<el-menu-item index="/skface-android-userhelp">使用说明</el-menu-item>
								<el-submenu index="4-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="/skface-android-skfaceinit">SDK初始化与释放</el-menu-item>
									<el-menu-item index="/skface-android-videotrackinit">视频人脸检测与识别</el-menu-item>
									<el-menu-item index="/skface-android-threshold">设置与获取人脸识别阈值</el-menu-item>
								</el-submenu>
								<el-submenu index="4-2">
									<template slot="title">拓展接口</template>
									<el-menu-item index="/skface-android-memory">人脸记忆功能</el-menu-item>
									<el-menu-item index="/skface-android-detectbuffer">清除缓存</el-menu-item>
									<el-menu-item index="/skface-android-getdeviceuniqueid">获取终端ID</el-menu-item>
									<el-menu-item index="/skface-android-setyuvformat">设置图像数据格式</el-menu-item>
								</el-submenu>
								<el-submenu index="4-3">
									<template slot="title">本地接口</template>
									<el-menu-item index="/skface-android-startregperson">开启与停止人脸注册</el-menu-item>
									<el-menu-item index="/skface-android-delperson">删除人员信息</el-menu-item>
									<el-menu-item index="/skface-android-setperson">设置人脸属性</el-menu-item>
									<el-menu-item index="/skface-android-getperson">获取本地人员识别信息</el-menu-item>
									<el-menu-item index="/skface-android-setuploadbuffer">设置识别记录的缓存上限</el-menu-item>
								</el-submenu>
								<el-submenu index="4-4">
									<template slot="title">事件接口</template>
									<el-menu-item index="/skface-android-registerevent">设置事件监听</el-menu-item>
								</el-submenu>
								<el-submenu index="4-5">
									<template slot="title">FRM接口</template>
									<el-menu-item index="/skface-android-bindfrminfo">绑定/解绑FRM</el-menu-item>
									<el-menu-item index="/skface-android-getdevicename">获取FRM终端名称</el-menu-item>
									<el-menu-item index="/skface-android-grouppath">获取人员组的路径信息</el-menu-item>
									<el-menu-item index="/skface-android-personlocalidserverid">本地人员ID的云端同步</el-menu-item>
									<el-menu-item index="/skface-android-getdevicepersonstructure">获取终端人员组织架构信息</el-menu-item>
								</el-submenu>
								<el-submenu index="4-6">
									<template slot="title">图片接口</template>
									<el-menu-item index="/skface-android-imagedetect">图片人脸检测与分析</el-menu-item>
									<el-menu-item index="/skface-android-featurecompare">人脸特征比对</el-menu-item>
								</el-submenu>
								<el-submenu index="4-7">
									<template slot="title">版本接口</template>
									<el-menu-item index="/skface-android-getsdkversion">获取SDK版本号</el-menu-item>
									<el-menu-item index="/skface-android-getkernelversion">获取人脸识别内核版本号</el-menu-item>
									<el-menu-item index="/skface-android-getmodelversion">获取Model版本号</el-menu-item>
								</el-submenu>
								<!--<el-submenu index="4-3">
									<template slot="title">视频接口</template>
									<el-menu-item index="sk-face-sdk-win-voideinitialization">视频初始化</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voideseetingstranger">设置“陌生人短时记忆功能”打开、关闭</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidedetectiontracking">人脸检测与跟踪</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidedefrminformation">获取FRM绑定信息</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidelocal">获取本机当前绑定信息</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidebindingfrm">绑定FRM</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voideuntyingfrm">解绑FRM</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voideseetingmonitor">设置事件监听</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidefaceregister">开启人脸注册</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidecancelfaceregister">取消人脸注册</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidegetpeople">获取人的信息</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidepeoplename">设置名字</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidesex">设置性别</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidebrithday">设置生日</el-menu-item>

									<el-menu-item index="sk-face-sdk-win-voidedetails">设置细节</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidedeletepeople">删除一个人</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidegetperson">获取当前设备所关联人员库Person数量</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidepeopleselect">获取认识的人列表</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidesetequipment">获取设备名称</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidegrouping">获取当前设备所拥有的人员分组结构</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidetransformation">人员本地ID转换为云端对应ID</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voidethreshold">设置人脸识别阈值</el-menu-item>
									<el-menu-item index="sk-face-sdk-win-voiderouter">人员的组ID转换为人员所在组的路径</el-menu-item>
								</el-submenu>	    -->
							</el-submenu>

							<el-submenu index="5">
								<template slot="title">
									<span>SKFaceLive-Android</span>
								</template>
								<el-menu-item index="/skface-live-android-userhelp">使用说明</el-menu-item>
								<el-submenu index="5-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="/skface-live-android-init">SDK初始化</el-menu-item>
									<el-menu-item index="/skface-live-android-getsdkversion">获取SDK版本号</el-menu-item>
									<el-menu-item index="/skface-live-android-getkernelversion">获得人脸识别内核版本号</el-menu-item>
									<el-menu-item index="/skface-live-android-getmodelversion">获取Model版本号</el-menu-item>
									<el-menu-item index="/skface-live-android-releasesdk">释放SDK资源</el-menu-item>				          					          	
								</el-submenu>
								<el-submenu index="5-2">
									<template slot="title">图片接口</template>
									<el-menu-item index="/skface-live-android-imagedetect">人脸检测</el-menu-item>
									<!-- <el-menu-item index="/skface-live-android-featurecompare">人脸比对</el-menu-item> -->
								</el-submenu>
								<el-submenu index="5-3">
									<template slot="title">视频接口</template>
									<el-menu-item index="/skface-live-android-videotrackinit">视频初始化</el-menu-item>
									<el-menu-item index="/skface-live-android-memory">设置“陌生人短时记忆功能”打开、关闭</el-menu-item>
									<el-menu-item index="/skface-live-android-videotrack">人脸检测与跟踪</el-menu-item>
									<el-menu-item index="/skface-live-android-livedetect">活体检测</el-menu-item>
									<el-menu-item index="/skface-live-android-withfeature">人证对比</el-menu-item>
									<el-menu-item index="/skface-live-android-bindfrminfo">获取FRM绑定信息</el-menu-item>
									<el-menu-item index="/skface-live-android-getdevicebindinfo">获取本机当前绑定信息</el-menu-item>
									<el-menu-item index="/skface-live-android-bindfrm">绑定FRM</el-menu-item>
									<el-menu-item index="/skface-live-android-unbindfrm">解绑FRM</el-menu-item>
									<el-menu-item index="/skface-live-android-registerevent">设置事件监听</el-menu-item>
									<el-menu-item index="/skface-live-android-startregperson">开启人脸注册</el-menu-item>
									<el-menu-item index="/skface-live-android-stopregperson">取消人脸注册</el-menu-item>
									<el-menu-item index="/skface-live-android-getpersoninfo">获取人的信息</el-menu-item>
									<el-menu-item index="/skface-live-android-setpersonname">设置名字</el-menu-item>
									<el-menu-item index="/skface-live-android-setpersonsex">设置性别</el-menu-item>
									<el-menu-item index="/skface-live-android-setpersonbirthday">设置生日</el-menu-item>
									<el-menu-item index="/skface-live-android-setpersondetailsinfo">设置细节</el-menu-item>
									<el-menu-item index="/skface-live-android-delperson">删除一个人</el-menu-item>
									<el-menu-item index="/skface-live-android-getPersondatabasenum">获取当前设备所关联人员库Person数量</el-menu-item>
									<el-menu-item index="/skface-live-android-getpersonlist">获取认识的人列表</el-menu-item>
									<el-menu-item index="/skface-live-android-getdevicename">获取设备名称</el-menu-item>
									<el-menu-item index="/skface-live-android-getdeviceperson">获取当前设备所拥有的人员分组结构</el-menu-item>
									<el-menu-item index="/skface-live-android-personlocalddserverid">人员本地ID转换为云端对应ID</el-menu-item>
									<el-menu-item index="/skface-live-android-setfacethreshold">设置人脸识别阈值</el-menu-item>
									<el-menu-item index="/skface-live-android-grouppath">人员的组ID转换为人员所在组的路径</el-menu-item>
								</el-submenu>	    
							</el-submenu>


							<el-submenu index="6">
								<template slot="title">
									<span>SKFaceLite-Android</span>
								</template>
								<el-menu-item index="/skface-lite-android-userhelp">使用说明</el-menu-item>
								<el-submenu index="6-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="/skface-lite-android-init">SDK初始化</el-menu-item>
									<el-menu-item index="/skface-lite-android-releasesDK">释放SDK资源</el-menu-item>
									<el-menu-item index="/skface-lite-android-videotrackinit">视频人脸识别与跟踪初始化</el-menu-item>
									<el-menu-item index="/skface-lite-android-videotrack">视频人脸检测与跟踪</el-menu-item>				          					          	
								</el-submenu>
								<el-submenu index="6-2">
									<template slot="title">版本接口</template>
									<el-menu-item index="/skface-lite-android-getsdkversion">获取SDK版本号</el-menu-item>
									<el-menu-item index="/skface-lite-android-getkernelversion">获得人脸识别内核版本号</el-menu-item>
									<el-menu-item index="/skface-lite-android-getmodelversion">获得Model版本号</el-menu-item>
								</el-submenu>									    
							</el-submenu>


							<el-submenu index="7">
								<template slot="title">
									<span>SKFaceFam-Android</span>
								</template>
								<el-menu-item index="/skface-family-android-userhelp">使用说明</el-menu-item>
								<el-submenu index="7-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="/skface-family-android-init">SDK初始化</el-menu-item>
									<el-menu-item index="/skface-family-android-getsdkversion">获取SDK版本号</el-menu-item>
									<el-menu-item index="/skface-family-android-getkernelversion">获得人脸识别内核版本号</el-menu-item>
									<el-menu-item index="/skface-family-android-getmodelversion">获取Model版本号</el-menu-item>
									<el-menu-item index="/skface-family-android-releasesdk">释放SDK资源</el-menu-item>				          					          	
								</el-submenu>
								<el-submenu index="7-2">
									<template slot="title">图片接口</template>
									<el-menu-item index="/skface-family-android-imagedetect">人脸检测</el-menu-item>
									<!-- <el-menu-item index="/skface-family-android-featurecompare">人脸比对</el-menu-item> -->
								</el-submenu>
								<el-submenu index="7-3">
									<template slot="title">视频接口</template>
									<el-menu-item index="/skface-family-android-videotrackinit">视频初始化</el-menu-item>
									<el-menu-item index="/skface-family-android-memory">设置“陌生人短时记忆功能”打开、关闭</el-menu-item>
									<el-menu-item index="/skface-family-android-videotrack">人脸检测与跟踪</el-menu-item>
									<el-menu-item index="/skface-family-android-bindfrminfo">获取FRM绑定信息</el-menu-item>
									<el-menu-item index="/skface-family-android-getdevicebindinfo">获取本机当前绑定信息</el-menu-item>
									<el-menu-item index="/skface-family-android-bindfrm">绑定FRM</el-menu-item>
									<el-menu-item index="/skface-family-android-unbindfrm">解绑FRM</el-menu-item>
									<el-menu-item index="/skface-family-android-registerevent">设置事件监听</el-menu-item>
									<el-menu-item index="/skface-family-android-startregperson">开启人脸注册</el-menu-item>
									<el-menu-item index="/skface-family-android-stopregperson">取消人脸注册</el-menu-item>
									<el-menu-item index="/skface-family-android-getpersoninfo">获取人的信息</el-menu-item>
									<el-menu-item index="/skface-family-android-setpersonname">设置名字</el-menu-item>
									<el-menu-item index="/skface-family-android-setpersonsex">设置性别</el-menu-item>
									<el-menu-item index="/skface-family-android-setpersonbirthday">设置生日</el-menu-item>
									<el-menu-item index="/skface-family-android-setpersondetails">设置细节</el-menu-item>
									<el-menu-item index="/skface-family-android-delperson">删除一个人</el-menu-item>
									<el-menu-item index="/skface-family-android-getpersondatabasenum">获取当前设备所关联人员库Person数量</el-menu-item>
									<el-menu-item index="/skface-family-android-getpersonlist">获取认识的人列表</el-menu-item>
									<el-menu-item index="/skface-family-android-getdevicename">获取设备名称</el-menu-item>
									<el-menu-item index="/skface-family-android-getdevicepersonstructure">获取当前设备所拥有的人员分组结构</el-menu-item>
									<el-menu-item index="/skface-family-android-personlocalidServerid">人员本地ID转换为云端对应ID</el-menu-item>
									<el-menu-item index="/skface-family-android-setfacethreshold">设置人脸识别阈值</el-menu-item>
									<el-menu-item index="/skface-family-android-grouppath">人员的组ID转换为人员所在组的路径</el-menu-item>
								</el-submenu>	    
							</el-submenu>

								<el-submenu index="9">
								<template slot="title">
									<span>SKFace-Windows</span>
								</template>
								<el-menu-item index="/skface-win-userhelp">使用说明</el-menu-item>
								<el-submenu index="9-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="/skface-win-init">SDK初始化</el-menu-item>
									<el-menu-item index="/skface-win-release">释放SDK资源</el-menu-item>
									<el-menu-item index="/skface-win-faceinitial">视频人脸识别与跟踪初始化</el-menu-item>
									<el-menu-item index="/skface-win-track">视频人脸检测与跟踪</el-menu-item>						
									<el-menu-item index="/skface-win-setthreshold">设置人脸识别阈值</el-menu-item>
									<el-menu-item index="/skface-win-getthreshold">获取人脸识别阈值</el-menu-item>
									
								</el-submenu>
								<el-submenu index="9-2">
									<template slot="title">本地接口</template>
									<el-menu-item index="/skface-win-startregisterperson">开启人脸注册</el-menu-item>
									<el-menu-item index="/skface-win-stopregperson">停止人脸注册</el-menu-item>
									<el-menu-item index="/skface-win-deleteperson">删除人员信息</el-menu-item>
									<el-menu-item index="/skface-win-setperson">设置人脸属性</el-menu-item>
									<el-menu-item index="/skface-win-setuploadbuffer">设置识别记录的缓存上限</el-menu-item>
									<el-menu-item index="/skface-win-getpersonlist">获取认识的人员数量及列表</el-menu-item>
									<el-menu-item index="/skface-win-getpersondetails">获取认识人员的详细信息</el-menu-item>
								</el-submenu>
								<el-submenu index="9-3">
									<template slot="title">事件接口</template>
									<el-menu-item index="/skface-win-seteventmonitor">设置事件监听</el-menu-item>
									<el-menu-item index="/skface-win-memory">短时记忆功能</el-menu-item>
								</el-submenu>
								<el-submenu index="9-4">
									<template slot="title">FRM接口</template>
									<el-menu-item index="/skface-win-getfrmbindcode">提取FRM绑定码信息</el-menu-item>
									<el-menu-item index="/skface-win-bindfrm">绑定FRM</el-menu-item>
									<el-menu-item index="/skface-win-untyingfrm">解绑FRM</el-menu-item>
									<el-menu-item index="/skface-win-getbindinformation">获取终端当前绑定信息</el-menu-item>
									<el-menu-item index="/skface-win-getdeviceallgroup">获取当前终端所拥有的人员分组结构</el-menu-item>
									<el-menu-item index="/skface-win-getfrmdevicename">获取FRM终端名称</el-menu-item>
									<el-menu-item index="/skface-win-grouppath">通过人员组ID获得人员组路径信息</el-menu-item>
									<el-menu-item index="/skface-win-personlocalidServerid">人员本地ID转换为云端对应ID</el-menu-item>
								</el-submenu>
								<el-submenu index="9-5">
									<template slot="title">图片接口</template>
									<el-menu-item index="/skface-win-imagedetect">人脸检测</el-menu-item>
									<!-- <el-menu-item index="/skface-win-facecontrast">人脸比对</el-menu-item> -->
								</el-submenu>
								<el-submenu index="9-6">
									<template slot="title">版本接口</template>
									<el-menu-item index="/skface-win-getsdkversion">获取SDK版本号</el-menu-item>
									<el-menu-item index="/skface-win-getfacekernel">获取人脸识别内核版本号</el-menu-item>
									<el-menu-item index="/skface-win-getmodeversion">获得Model版本号</el-menu-item>
								</el-submenu>
							</el-submenu>
							
							<el-submenu index="8">
								<template slot="title">
									<span>SKFaceLive-Windows</span>
								</template>
								<el-menu-item index="/skface-live-win-userhelp">使用说明</el-menu-item>
								<el-submenu index="8-1">
									<template slot="title">基础接口</template>
									<el-menu-item index="/skface-live-win-init">SDK初始化</el-menu-item>
									<el-menu-item index="/skface-live-win-release">释放SDK资源</el-menu-item>
									<el-menu-item index="/skface-live-win-faceinitial">视频人脸识别与跟踪初始化</el-menu-item>
									<el-menu-item index="/skface-live-win-track">视频人脸检测与跟踪</el-menu-item>
									<el-menu-item index="/skface-live-win-facelivetrack">活体视频检测与追踪</el-menu-item>
									<el-menu-item index="/skface-live-win-personcardtrack">视频人证比对与追踪</el-menu-item>
									<el-menu-item index="/skface-live-win-setfacethreshold">设置人脸识别阈值</el-menu-item>
									<el-menu-item index="/skface-live-win-getfacethreshold">获取人脸识别阈值</el-menu-item>
									<el-menu-item index="/skface-live-win-setpersonandcard">设置人证比对阈值</el-menu-item>
									<el-menu-item index="/skface-live-win-getpersonandcard">获取人证比对阈值</el-menu-item>
								</el-submenu>
								<el-submenu index="8-2">
									<template slot="title">本地接口</template>
									<el-menu-item index="/skface-live-win-startregisterperson">开启人脸注册</el-menu-item>
									<el-menu-item index="/skface-live-win-stopregperson">停止人脸注册</el-menu-item>
									<el-menu-item index="/skface-live-win-deleteperson">删除人员信息</el-menu-item>
									<el-menu-item index="/skface-live-win-setperson">设置人脸属性</el-menu-item>
									<el-menu-item index="/skface-live-win-setupperlimit">设置识别记录的缓存上限</el-menu-item>
									<el-menu-item index="/skface-live-win-getpersonlist">获取认识的人员数量及列表</el-menu-item>
									<el-menu-item index="/skface-live-win-getpersondetails">获取认识人员的详细信息</el-menu-item>
								</el-submenu>
								<el-submenu index="8-3">
									<template slot="title">事件接口</template>
									<el-menu-item index="/skface-live-win-seteventmonitor">设置事件监听</el-menu-item>
									<el-menu-item index="/skface-live-win-memory">短时记忆功能</el-menu-item>
								</el-submenu>
								<el-submenu index="8-4">
									<template slot="title">FRM接口</template>
									<el-menu-item index="/skface-live-win-getfrmbindcode">提取FRM绑定码信息</el-menu-item>
									<el-menu-item index="/skface-live-win-bindfrm">绑定FRM</el-menu-item>
									<el-menu-item index="/skface-live-win-untyingfrm">解绑FRM</el-menu-item>
									<el-menu-item index="/skface-live-win-getbindinformation">获取终端当前绑定信息</el-menu-item>
									<el-menu-item index="/skface-live-win-getdeviceallgroup">获取当前终端所拥有的人员分组结构</el-menu-item>
									<el-menu-item index="/skface-live-win-getfrmdevicename">获取FRM终端名称</el-menu-item>
									<el-menu-item index="/skface-live-win-grouppath">通过人员组ID获得人员组路径信息</el-menu-item>
									<el-menu-item index="/skface-live-win-personlocalidServerid">人员本地ID转换为云端对应ID</el-menu-item>
								</el-submenu>
								<el-submenu index="8-5">
									<template slot="title">图片接口</template>
									<el-menu-item index="/skface-live-win-imagedetect">人脸检测</el-menu-item>
									<!-- <el-menu-item index="/skface-live-win-facecontrast">人脸比对</el-menu-item> -->
								</el-submenu>
								<el-submenu index="8-6">
									<template slot="title">版本接口</template>
									<el-menu-item index="/skface-live-win-getsdkversion">获取SDK版本号</el-menu-item>
									<el-menu-item index="/skface-live-win-getfacekernel">获取人脸识别内核版本号</el-menu-item>
									<el-menu-item index="/skface-live-win-getmodeversion">获得Model版本号</el-menu-item>
								</el-submenu>
							</el-submenu>				
					</el-submenu>

	
					  


						
					    <el-submenu index="frmface">
					        <template slot="title">
					          	<span>FRM API-v2</span>
					        </template>
						
							<el-menu-item index="/skfrm-userhelp">使用说明</el-menu-item>
								
						
					       <el-submenu index="17">
								<template slot="title">
									<span>账号登录</span>
								</template>				
									<el-menu-item index="/skfrm-login">登录</el-menu-item>
							</el-submenu>
							<el-submenu index="18">
								<template slot="title">
									<span>账号设置</span>
								</template>				
									<el-menu-item index="/skfrm-account_info">获取账号信息</el-menu-item>
							</el-submenu>
							<el-submenu index="19">
								<template slot="title">
									<span>子账号管理</span>
								</template>				
									<el-menu-item index="/skfrm-subaccount_add">添加子账号</el-menu-item>
									<el-menu-item index="/skfrm-subaccount_info">获取子账号信息</el-menu-item>
									<el-menu-item index="/skfrm-subaccount_set">设置子账号信息</el-menu-item>
									<!--<el-menu-item index="sk-frm-Deletesubaccountinformation">删除子账号信息(暂无)</el-menu-item>-->
									<el-menu-item index="/skfrm-subaccount_list">获取子账号列表</el-menu-item>
							</el-submenu>
							<el-submenu index="20">
								<template slot="title">
									<span>项目管理</span>
								</template>				
									<el-menu-item index="/skfrm-project_add">添加项目</el-menu-item>
									<el-menu-item index="/skfrm-project_set">设置项目属性</el-menu-item>
									<el-menu-item index="/skfrm-project_info">获取项目信息</el-menu-item>
									<!--<el-menu-item index="sk-frm-deleteitem">删除项目(暂无)</el-menu-item>-->
									<el-menu-item index="/skfrm-project_list">获取项目列表</el-menu-item>
							</el-submenu>
							<el-submenu index="21">
								<template slot="title">
									<span>人员管理</span>
								</template>				
									<el-menu-item index="/skfrm-person_add">添加人员</el-menu-item>
									<el-menu-item index="/skfrm-person_info">获取人员信息</el-menu-item>
									<el-menu-item index="/skfrm-pgroup_set">设置人员信息</el-menu-item>
									<el-menu-item index="/skfrm-person_show_image">设置人员展示图</el-menu-item>
									<el-menu-item index="/skfrm-person_del">移除人员</el-menu-item>
									<el-menu-item index="/skfrm-person_movel">移动人员</el-menu-item>
									<el-menu-item index="/skfrm-person_copy">复制人员</el-menu-item>
									<el-menu-item index="/skfrm-person_list">获取人员组人员列表</el-menu-item>				
									<el-menu-item index="/skfrm-pgroup_add">添加人员组</el-menu-item>				
									<el-menu-item index="/skfrm-set_person_info">设置人员组信息</el-menu-item>
									<el-menu-item index="/skfrm-pgroup_del">删除人员组</el-menu-item>
									<el-menu-item index="/skfrm-pgroup_copy">复制人员组</el-menu-item>
									<el-menu-item index="/skfrm-pgroup_move">移动人员组</el-menu-item>
									<el-menu-item index="/skfrm-get_pgroup_hierarchy">获取人员组结构</el-menu-item>
							</el-submenu>
							<el-submenu index="22">
								<template slot="title">
									<span>终端管理</span>
								</template>				
									<el-menu-item index="/skfrm-terminal_info">获取终端信息</el-menu-item>
									<el-menu-item index="/skfrm-terminal_set">设置终端信息</el-menu-item>
									<el-menu-item index="/skfrm-tgroup_show_image">设置终端主题图</el-menu-item>
									
									<el-menu-item index="/skfrm-terminal_move">移动终端</el-menu-item>
									<el-menu-item index="/skfrm-terminal_del">移除终端</el-menu-item>
									<el-menu-item index="/skfrm-tgroup_add">添加终端组</el-menu-item>
									<el-menu-item index="/skfrm-tgroup_set">设置终端组名称</el-menu-item>
									<el-menu-item index="/skfrm-tgroup_move">移动终端组</el-menu-item>
									<el-menu-item index="/skfrm-tgroup_del">移除终端组</el-menu-item>
									<el-menu-item index="/skfrm-terminal_list">获取全部终端</el-menu-item>
									<el-menu-item index="/skfrm-get_tgroup_hierarchy">获取终端组结构</el-menu-item>
									<el-menu-item index="/skfrm-person2terminal">设置终端组的可识别人员组</el-menu-item>
									<el-menu-item index="/skfrm-terminal_binding_code">生成终端组绑定码</el-menu-item>
									<el-menu-item index="/skfrm-person2terminal_info">获取终端组可识别人员组</el-menu-item>
							</el-submenu>
							<el-submenu index="23">
								<template slot="title">
									<span>人脸分析</span>
								</template>				
									<el-menu-item index="/skfrm-face_detect">人脸检测</el-menu-item>
									<!-- <el-menu-item index="/skfrm-face_compare">人脸比对</el-menu-item> -->
									<el-menu-item index="/skfrm-feature_extract">特征提取</el-menu-item> 
							</el-submenu>
							<el-submenu index="24">
								<template slot="title">
									<span>统计信息</span>
								</template>				
									<el-menu-item index="/skfrm-person_record">获取人员/人员组的识别记录</el-menu-item>
									<el-menu-item index="/skfrm-terminal_record">获取终端/终端组的识别记录</el-menu-item>
									<el-menu-item index="/skfrm-account_record">获取账号下的识别记录</el-menu-item>
							</el-submenu>
							<el-submenu index="25">
								<template slot="title">
									<span>消息推送</span>
								</template>				
									<el-menu-item index="/skfrm-message_push">消息推送</el-menu-item>
							</el-submenu>
							<el-menu-item index="/skfrm-status_code">状态码</el-menu-item>
					    </el-submenu>
					    
					    
				    </el-menu>
				</div>
			</div>
			<div class="main_content" ref="mainContent">
				<router-view/>
			</div>
			<div class="main_right_nav" ref="mainRightNav"></div>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				screenWidth:document.body.clientWidth,//屏幕宽度
				screenHeight:document.body.clientHeight,//屏幕高度
				timer:false,
				activeIndex:null,//当前展开项名称
				heightTimer:false,//竖向拉伸页面
			}
		},
		watch:{
			screenWidth (val) { //监听页面横向改变
                if (!this.timer) {
                    this.screenWidth = val
                    this.timer = true
                    setTimeout(()=>{
                        // that.screenWidth = that.$store.state.canvasWidth
                        console.log(this.screenWidth)
                        if (this.screenWidth>1397){
                        	this.$refs.mainLeftMent.style.left = (this.screenWidth-952)/2-230+"px";//左侧导航left值
							this.$refs.mainContent.style.width = 952+"px"//设置主体宽度
							this.$refs.mainRightNav.style.left = (this.screenWidth-952)/2+952+80+"px";//右侧锚点left值
						}else {
							this.$refs.mainLeftMent.style.left = 445/2-230+"px";//左侧导航left值
							this.$refs.mainContent.style.width = (this.screenWidth-270-175)+"px"//设置主体宽度
							this.$refs.mainRightNav.style.left = (this.screenWidth-(this.screenWidth-270-175))/2+(this.screenWidth-270-175)+80+"px";//右侧锚点left值
						}
                        // this.init()
                        this.timer = false
                    },200)
                }
            },
            screenHeight(val){//监听页面纵向改变
            	if (!this.heightTimer) {
                    this.screenHeight = val
                    this.heightTimer = true
                    setTimeout(()=>{
                        // that.screenWidth = that.$store.state.canvasWidth
                        this.$refs.mainLeftMent.style.height = this.screenHeight-150+"px";
                        this.heightTimer = false
                    },200)
                }
            }
		},
		methods:{
			onRoutes: function () {
				return this.$route.path
			},
			handleOpen(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClose(key, keyPath) {
		        console.log(key, keyPath);
		    },
			handleScrollX(){//设置横向滚动
				
				if (this.$refs.mainLeftMent) {
					this.$refs.mainLeftMent.style.marginLeft = (20-window.scrollX)+"px";	//左侧滚动位置
				}
			  	
			  	if (this.$refs.mainRightNav) {
			  		this.$refs.mainRightNav.style.marginLeft = -window.scrollX+"px";	//右侧滚动位置
			  	}
			  	
			},
			handleScrollY(){
			  console.log(window.scrollY)
			  if (window.scrollY<60){
			  	//console.log(this.$refs.mainLeftMent.style.top)
			  }else {
			  	//this.$refs.mainLeftMent.style.top = 
			  }
			},
		},
		mounted(){
			window.addEventListener('scroll', this.handleScrollX)
			window.addEventListener('scroll', this.handleScrollY)
			let that = this
			if (this.screenWidth>1397){
				this.$refs.mainLeftMent.style.left = (this.screenWidth-952)/2-230+"px";//左侧导航left值
				this.$refs.mainContent.style.width = (1397-270-175)+"px"//主体宽度
				this.$refs.mainRightNav.style.left = (this.screenWidth-952)/2+952+80+"px";//右侧锚点left值
			}else {
				this.$refs.mainLeftMent.style.left = 445/2-230+"px";//左侧导航left值
				this.$refs.mainContent.style.width = (this.screenWidth-270-175)+"px"//主体宽度
				this.$refs.mainRightNav.style.left = (this.screenWidth-(this.screenWidth-270-175))/2+(this.screenWidth-270-175)+80+"px";//右侧锚点left值
			}
			//响应左侧浮框高度
			this.$refs.mainLeftMent.style.height = this.screenHeight-150+"px";
			// console.log(this.screenHeight,this.$refs.mainLeftMent.style.height,"this.screenHeight")
            window.onresize = () => {//绑定页面改变事件
                return (() => {
                    window.screenWidth = document.body.clientWidth//横向
                    that.screenWidth = window.screenWidth
                    window.screenHeight = document.body.clientHeight//纵向
                    that.screenHeight = window.screenHeight
                })()
            }
            console.log(this.$route.name,'documentIndex')
            this.activeIndex = this.$route.name
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../less/index.less';
	.document_index{
		padding-top:90px;
	    overflow: hidden;
	    max-width: 1397px;
	    min-width: 1200px;
	    width: auto;
	    //position: relative;
	    text-align: center;
	    margin: 0 auto;
	    padding-bottom:45px;
	    .doc_content{
	    	width: 100%;
	    	height: 100%;
	    	position: relative;
	    	.main_left_menu{//左侧折叠目录
	    		left: 40px;
			    top: 92px;
			    margin-left: 20px;
	    		position: fixed;
			    text-align: left;
			    margin-left: 20px;
			    width: 220px;
			    transition: left .3s ease-out;
			    overflow: hidden;
			    height: 500px;
			    padding-bottom:15px;
			    .el-menu{background: #F7F7F7;}
			    .el_menu_left{
			    	background: #F7F7F7;
			    	border-right:solid 1px #F7F7F7;
			    	//height: 500px;
			    	//height: calc(100% - 45px);
			    	.el-submenu__title,.el-menu-item{
			    		height: auto;
						line-height: 1;
						padding-top:15px;
						padding-bottom:15px;
						word-wrap:break-word; 
						word-break:normal;
						white-space: normal;
						font-size: 15px;
			    	}
			    	.el-submenu__title:hover,.el-menu-item:hover {
					    background-color: #FCECD5;
					    color:@primary-color;
					}
					.el-submenu__title.is-active,.el-menu-item.is-active {
					    background-color: #FCECD5;
					    color:@primary-color;
					}
					.el-submenu .el-menu-item{
						height: auto;
						line-height: 1;
						padding-top:15px;
						padding-bottom:15px;
						word-wrap:break-word;
						word-break:normal;
						white-space: normal;
						font-size: 15px;
					}
			    }
			    .left_title{
			    	height: 50px;
			    	background: #F7F7F7;
			    	width: 100%;
			    	// border-right:solid 1px #e6e6e6;
			    	border-bottom:2px solid #e6e6e6;

			    	span{
			    		float: left;
			    		height: 50px;
			    		line-height: 50px;
			    		font-size: 18px;
			    		font-weight: 600;
			    		color:#4f4f4f;
			    		padding-left:20px;
			    	}
			    	.el-icon-menu{
			    		float: right;
			    		font-size: 30px;
			    		margin-top: 10px;
			    		margin-right: 10px;
			    		cursor:pointer;
			    	}
			    }
	    	}
	    	.doc_left_sidebar{
	    		width: 238px;
			    overflow-y: scroll;
			    //
			    height:calc(~"100% - 52px");
			    background: #F7F7F7;
	    	}
	    	.main_content{//中间文档内容
    		    max-width: 952px;
			    min-width: 755px;
			    background-color: #fff;
			    box-sizing: border-box;
			    margin-left: 270px;
			    margin-right: 175px;
			    display: inline-block;
			    text-align: left;
			    transition: margin-left .3s ease-out;
	    	}
	    	.main_right_nav{//右侧导航锚点
    		    left: 1040px;
			    top: 152px;
			    margin-left: 0px;
	    		position: fixed;
			    background-color: transparent;
			    width: 160px;
			    font-size: 14px;
			    line-height: 30px;
			    color: gray;
			    text-align: left;
			    padding: 9px 0;
			    transition: left .3s ease-out;
			    overflow: hidden;
	    	}
	    }
	}
	.el-table .el-table__row .el-table_2_column_7 .cell {
        white-space: pre-line!important;
    }
</style>


// WEBPACK FOOTER //
// src/views/documents/documentIndex.vue